// src/api/FileUploadApi.js
import axios from 'axios';
import Swal from 'sweetalert2';
import { redirectToSessionExpired } from '../utils/session';

export class FileUploadApi {
  constructor(baseURL) {
    this.client = axios.create({
      baseURL,
    });
    this.client.interceptors.request.use((config) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      // Set Content-Type for file upload only
      config.headers['Content-Type'] = 'multipart/form-data';
      config.headers['Accept'] = 'application/json';
      return config;
    });

    this.client.interceptors.response.use(
      (response) => response,
      (error) => {
        const status = error.response?.status;
        error.handled = true;

        if (status === 401) {
          redirectToSessionExpired('Your session has expired. Please login again.');
        } else if (status === 403) {
          Swal.fire({
            icon: 'error',
            title: 'Access Denied',
            text: 'You do not have permission to perform this action. Please contact your administrator.',
            confirmButtonText: 'OK',
            confirmButtonColor: '#d33',
          });
        } else {
          const message =
            error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            'File upload failed. Please try again.';
          Swal.fire({
            icon: 'error',
            title: 'Upload Error',
            text: message,
            confirmButtonText: 'OK',
          });
        }

        return Promise.reject(error);
      }
    );
  }

  upload(formData, config = {}) {
    return this.client.post('/api/v1/contacts/upload-documents', formData, config);
  }
  uploadProfileImage(formData, config = {}) {
    return this.client.post('/api/v1/contacts/upload-profile-image', formData, config);
  }
}
